import { useTranslation } from 'react-i18next';
import { mainWebsiteUrl } from '@/mocks/categories';

export default function FinalCta() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden bg-primary-500">
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20minimal%20flat%20lay%20of%20streetwear%20fashion%20items%20sneakers%20caps%20and%20folded%20clothing%20on%20a%20sage%20green%20background%20subtle%20grid%20texture%20premium%20editorial%20style%20calm%20high%20detail&width=1600&height=600&seq=usfans-cta-02&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-16 text-center md:px-6 md:py-24">
        <h2 className="font-heading text-2xl font-semibold text-white md:text-4xl">{t('final_title')}</h2>
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-white/90 md:text-base">
          {t('final_desc')}
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href={mainWebsiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100 sm:w-auto whitespace-nowrap cursor-pointer"
          >
            {t('final_cta_main')}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </a>
          <a
            href={mainWebsiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/40 bg-white/10 px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-white/20 sm:w-auto whitespace-nowrap cursor-pointer"
          >
            {t('final_cta_buy')}
          </a>
        </div>
      </div>
    </section>
  );
}